// extracted by mini-css-extract-plugin
export default {"container":"CleanUpBoard_container__UuKIt","header":"CleanUpBoard_header__ViOJZ","contextWrapper":"CleanUpBoard_contextWrapper__VeaZH"};